import { render, staticRenderFns } from "./screenHome.vue?vue&type=template&id=37a39bd5&"
import script from "./screenHome.vue?vue&type=script&lang=js&"
export * from "./screenHome.vue?vue&type=script&lang=js&"
import style0 from "./screenHome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports